export default function pluck(array, key) {
  return array.map((o) => o[key]);
}
